import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './styles.css';

const ModalAddCustomResponse = ({ isOpen, onClose, onSubmit }) => {
    const { t } = useTranslation('botConfig');

    const validationSchema = Yup.object({
        question: Yup.string()
            .required(t('validation.questionRequired'))
            .min(3, t('validation.questionMinLength'))
            .max(100, t('validation.questionMaxLength')),
        response: Yup.string()
            .required(t('validation.responseRequired'))
            .min(10, t('validation.responseMinLength'))
            .max(300, t('validation.responseMaxLength'))
    });

    const PREFIX_TEXT = t('addModal.prefix');

    const initialValues = {
        question: '',
        response: ''
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const finalValues = {
                ...values,
                question: PREFIX_TEXT + values.question
            };
            await onSubmit(finalValues, { setSubmitting, resetForm });
        } catch (error) {
            setSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="custom-response-modal">
                <div className="custom-response-modal-header">
                    <h2 className="custom-response-modal-title">{t('addModal.title')}</h2>
                    <p className="custom-response-modal-subtitle">{t('addModal.description')}</p>
                </div>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, values }) => (
                        <Form className="custom-response-form">
                            <div className="custom-response-field-group">
                                <label htmlFor="question" className="custom-response-field-label">
                                    {t('addModal.whenToUseLabel')}
                                </label>
                                <div className="custom-response-question-wrapper">
                                    <span className="custom-response-prefix">{PREFIX_TEXT}</span>
                                    <Field
                                        as="textarea"
                                        id="question"
                                        name="question"
                                        placeholder={t('addModal.questionPlaceholder')}
                                        className="custom-response-question-input"
                                        rows="3"
                                    />
                                </div>
                                <ErrorMessage name="question" component="div" className="custom-response-error" />
                            </div>

                            <div className="custom-response-field-group">
                                <label htmlFor="response" className="custom-response-field-label">
                                    {t('addModal.instructionsLabel')}
                                </label>
                                <Field
                                    as="textarea"
                                    id="response"
                                    name="response"
                                    placeholder={t('addModal.responsePlaceholder')}
                                    className="custom-response-textarea"
                                    rows="6"
                                />
                                <ErrorMessage name="response" component="div" className="custom-response-error" />
                                <div className="custom-response-char-count">
                                    {values.response.length}/300
                                </div>
                            </div>

                            <div className="custom-response-actions">
                                <button
                                    type="button"
                                    className="custom-response-btn custom-response-btn-cancel"
                                    onClick={onClose}
                                    disabled={isSubmitting}
                                >
                                    {t('addModal.cancel')}
                                </button>
                                <button
                                    type="submit"
                                    className="custom-response-btn custom-response-btn-submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? t('addModal.adding') : t('addModal.add')}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Modal>
    );
};

export default ModalAddCustomResponse;
